/* eslint-disable no-console */
import {InfoCircleOutlined} from '@ant-design/icons';
import {Flex, Row} from 'antd';
import React, {useEffect, useState} from 'react';

import Loader from '../../components/Loader/Loader';
import PageContent from '../../components/PageContent/PageContent';
import {subscriptionPlanTypes} from '../../constants/subscriptionConstants';
import pricingDetails from '../../services/modules/OM/pricingDetails';
import ComparePlansJson from '../../staticJson/comparePlans.json';
import PricingPlanJson from '../../staticJson/pricingPlanJson.json';
import useCompanyStore from '../../store/companyStore/companyDetailsStore';
import {FirstCap} from '../../utils/FormUtils/FirstCap';

import ComparePlans from './ComparePlans';
import ContactTeam from './ContactTeam';
import PricingPlansDetails from './PricingPlansDetails';

const PricingPlansPage: React.FC = () => {
  const activePlan = useCompanyStore((s) => s.subscription?.planType);
  const endDate = useCompanyStore((s) => s.subscription?.endDate);

  const [pricingDetail, setPricingDetail] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const formatDate = (isoString: string): string => {
    try {
      const d = new Date(isoString);

      const day = String(d.getUTCDate()).padStart(2, '0');
      const month = d.toLocaleString('en-US', {
        month: 'short',
        timeZone: 'UTC'
      });
      const year = d.getUTCFullYear();

      return `${day} ${month}, ${year}`;
    } catch {
      return '-';
    }
  };

  useEffect(() => {
    pricingDetails()
      .then((response) => {
        const dbPlans = response;

        const enrichedData = PricingPlanJson.map((item) => {
          const dbItemData = dbPlans?.find((dbItem: any) => {
            return dbItem?.planType === item.planType;
          });

          const dbPrice = dbItemData?.basePrice ?? 0;

          const dbGstPercentage = dbItemData?.taxInPercentage ?? 0;

          const monthlyPrice =
            item.planType === subscriptionPlanTypes.ENTERPRISE
              ? ''
              : item.planType === subscriptionPlanTypes.FREE
                ? '0'
                : dbPrice?.toLocaleString('en-IN');

          return {
            ...item,
            pricePerMonth: monthlyPrice,
            pricePerYear:
              item.planType === subscriptionPlanTypes.FREE ||
              item.planType === subscriptionPlanTypes.ENTERPRISE
                ? ''
                : (dbPrice * 12)?.toLocaleString('en-IN'),
            yearWiseDiscountGST:
              item.planType === subscriptionPlanTypes.FREE ||
              item.planType === subscriptionPlanTypes.ENTERPRISE
                ? ''
                : `${dbGstPercentage}%`
          };
        });

        setPricingDetail(enrichedData);
        setIsLoading(false);
      })
      .catch(() => {
        setIsLoading(false);
        setPricingDetail(PricingPlanJson);
      });
  }, []);

  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        <Flex className="pricingDetails" vertical gap={30}>
          <PageContent>
            <Flex className="pricingPlanMainContainer" vertical>
              <Flex
                vertical
                align="center"
                gap={12}
                style={{width: '100%', paddingLeft: 20, paddingRight: 20}}
              >
                <div className="pricingMadeSimple">Pricing Made Simple</div>
                <div className="explorePlanDescription">
                  Explore our plans, tailored for businesses at every stage of
                  your climate journey—packed with powerful features, expert
                  tools, and scalable sustainability solutions.
                </div>
                <Flex
                  className="explorePlanDescription backGroundColor"
                  gap={10}
                >
                  <InfoCircleOutlined />
                  <div>
                    You’re currently in{' '}
                    <span className="planTypeText">
                      {FirstCap(activePlan?.toLocaleLowerCase())}
                    </span>{' '}
                    plan
                    {activePlan === subscriptionPlanTypes.ENTERPRISE
                      ? ', our most upgraded plan.'
                      : '. Pick your desired plan from below for more meaningful activity!'}
                  </div>
                </Flex>
                {activePlan === subscriptionPlanTypes.PRO ||
                activePlan === subscriptionPlanTypes.PLUS ? (
                  <div style={{fontWeight: 600}}>
                    Plan expires on <b>{formatDate(endDate)}</b>
                  </div>
                ) : null}
              </Flex>
              <Row gutter={[16, 30]}>
                <PricingPlansDetails
                  key={'pricing_items'}
                  data={pricingDetail}
                />
              </Row>
            </Flex>
          </PageContent>
          <ContactTeam />
          <ComparePlans comparisonData={ComparePlansJson} />
        </Flex>
      )}
    </>
  );
};

export default PricingPlansPage;
